enum SecretSearchContext {
  PERSONS = 'Persons',
}

export default SecretSearchContext
